/**
 * useScrollFadeIn — applique une animation fadeUp à un élément
 * lorsqu'il devient visible. Renvoie [ref, style].
 */
import { useEffect, useRef, useState } from "react";

export function useScrollFadeIn({ delay = 0, threshold = 0.1 } = {}) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);

  const style = {
    opacity: visible ? 1 : 0,
    transform: visible ? "translateY(0)" : "translateY(24px)",
    transition: `opacity 700ms cubic-bezier(0.4,0,0.2,1) ${delay}ms, transform 700ms cubic-bezier(0.4,0,0.2,1) ${delay}ms`,
    willChange: "opacity, transform",
  };

  return [ref, style];
}

export default useScrollFadeIn;
